import { ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { list as getUpcomingList, UpcomingQuery } from '@/services/api/resources/upcoming';

export const useUpcomingForms = () => {
  const checkLoading = ref<boolean>(true);
  const checkResult = ref<boolean>();

  const checkQuery = (): UpcomingQuery => ({
    page: 1,
    perPage: 1,
    sort: '',
    dir: '',
    timezone: '',
    search: '',
    assignee: [],
    entityItem: [],
    availableAtStart: null,
    availableAtEnd: null,
  });

  const performCheck = useTask(
    () => getUpcomingList(checkQuery()),
    response => {
      checkResult.value = response.data.length > 0;
      checkLoading.value = false;
    },
  );

  return {
    checkLoading,
    checkResult,
    performCheck,
  };
};
